export function isDefined<T>(value: T | undefined | null): value is NonNullable<T> {
  return value !== undefined && value !== null
}

export function formatAMPM(date: Date) {
  let hours = date.getHours()
  const minutes = date.getMinutes()
  const ampm = hours >= 12 ? 'pm' : 'am'
  hours = hours % 12
  hours = hours || 12 // the hour '0' should be '12'
  const realMinutes = minutes < 10 ? `0${minutes}` : minutes
  const strTime = `${hours}:${realMinutes} ${ampm}`
  return strTime
}

export function toDataURL(url: string, callback: (value: string | ArrayBuffer | null) => any) {
  const xhr = new XMLHttpRequest()
  xhr.onload = function () {
    const reader = new FileReader()
    reader.onloadend = function () {
      callback(reader.result)
    }
    reader.readAsDataURL(xhr.response)
  }
  xhr.open('GET', url)
  xhr.responseType = 'blob'
  xhr.send()
}

// Function to check if a string is a base64 PNG image
export function isBase64PngImage(str: string) {
  // Check if the string starts with the base64 PNG header
  if (str.startsWith('data:image/png;base64,')) {
    // Remove the header to get just the base64 data
    const base64Data = str.replace('data:image/png;base64,', '')

    // Create a temporary image element to check if the base64 data is a valid PNG image
    const img = new Image()
    img.src = `data:image/png;base64,${base64Data}`

    // Check if the image is a valid PNG image
    if (img.complete && img.naturalWidth !== 0)
      return true // It is a valid PNG image
  }

  return false // Not a valid PNG image
}

export function getLocalStream() {
  navigator.mediaDevices
    .getUserMedia({ video: false, audio: true })
    .then((stream) => {
      // @ts-expect-error types
      window.localStream = stream // A
      // @ts-expect-error types
      window.localAudio.srcObject = stream // B
      // @ts-expect-error types
      window.localAudio.autoplay = true // C
    })
    .catch((err) => {
      console.error(`you got an error: ${err}`)
    })
}
